import { SLOT_ITEM, ELEMENT_TYPE } from "@/constants";
import api from "@/apis/index";
import { RES_COMMON_CODE } from "@mono/network/constant";
import _ from "lodash";
import { isWyak, isWeParty, isInChat } from "@mono/utils";

function getSlotLogo() {
  if (isWyak) {
    return require("@/assets/slot_wyak.png");
  } else if (isWeParty) {
    return require("@/assets/slot_weparty.png");
  } else if (isInChat) {
    return require("@/assets/slot_inchat.png");
  } else {
    return require("@/assets/slot_lama.png");
  }
}

export function getSlotItemIcon(id) {
  if (id == SLOT_ITEM.BANANA) {
    return require("@/assets/slot_banana.png");
  } else if (id == SLOT_ITEM.LEMON) {
    return require("@/assets/slot_lemon.png");
  } else if (id == SLOT_ITEM.CHERRY) {
    return require("@/assets/slot_cherry.png");
  } else if (id == SLOT_ITEM.STRAWBERRY) {
    return require("@/assets/slot_strawberry.png");
  } else if (id == SLOT_ITEM.COKE) {
    return require("@/assets/slot_coke.png");
  } else if (id == SLOT_ITEM.CHIPS) {
    return require("@/assets/slot_chips.png");
  } else if (id == SLOT_ITEM.HAMBURGER) {
    return require("@/assets/slot_hamburger.png");
  } else if (id == SLOT_ITEM.PIZZA) {
    return require("@/assets/slot_pizza.png");
  } else if (id == SLOT_ITEM.CLOVER) {
    return require("@/assets/slot_clover.png");
  } else if (id == SLOT_ITEM.DICE) {
    return require("@/assets/slot_dice.png");
  } else if (id == SLOT_ITEM.CHEST) {
    return require("@/assets/slot_chest.png");
  } else if (id == SLOT_ITEM.LAMA) {
    return getSlotLogo();
  } else {
    return "";
  }
}

export const PAGE_SIZE = 20;

const FreeOdds = [
  {
    left: 3,
    odd: 5,
  },
  {
    left: 4,
    odd: 10,
  },
  {
    left: 5,
    odd: 20,
  },
];

export default {
  namespaced: true,
  state: () => ({
    balance: 0, //金币余额
    bonusOpen: false, //bonus game是否开奖
    userSlotHistoryList: [], //游戏历史记录
    slotHistoryListNextOffset: 1,
    slotHistoryListRefreshing: false,
    slotHistoryListLoading: true,
    slotHistoryListFinished: false,
    slotHistoryListError: false,
    slotNormalElements: [],
    slotSpecialElements: [],
  }),
  mutations: {
    updateBalance(state, payload) {
      state.balance = payload.data;
    },
    updateBonusOpen(state, payload) {
      state.bonusOpen = payload.data;
    },
    updateUserSlotHistoryList(state, payload) {
      state.userSlotHistoryList = payload.data;
      state.slotHistoryListFinished = payload.finished;
      state.slotHistoryListNextOffset = payload.nextOffset;
    },
    updateUserListRefreshing(state, payload) {
      state.slotHistoryListRefreshing = payload.data;
    },
    updateUserListLoading(state, payload) {
      state.slotHistoryListLoading = payload.data;
    },
    updateUserListFinished(state, payload) {
      state.slotHistoryListFinished = payload.data;
    },
    updateUserListError(state, payload) {
      state.slotHistoryListError = payload.data;
    },
    updateSlotElement(state, payload) {
      state.slotNormalElements = payload.normal;
      state.slotSpecialElements = payload.special;
    },
  },
  actions: {
    async requestBalance({ commit }, currencies) {
      const res = await api.getMyCoins(currencies);
      const { code, data } = res;
      if (code == RES_COMMON_CODE.SUCCESS) {
        const currency = data.currencyInfo[0];
        if (currency) {
          commit("updateBalance", { data: currency.currencyValue });
        }
      }
    },
    localUpdateBalance({ commit }, payload) {
      commit("updateBalance", { data: payload.balance });
    },
    updateBonusGameOpenStatus({ commit }, payload) {
      commit("updateBonusOpen", { data: payload.data });
    },
    async getUserSlotInfoList({ state, commit }, payload) {
      let isRefresh = payload.refresh;
      if (isRefresh) {
        commit("updateUserListRefreshing", { data: true });
        commit("updateUserListFinished", { data: false });
      }
      var pageOffset = isRefresh ? 1 : state.slotHistoryListNextOffset;
      commit("updateUserListLoading", { data: true });
      const res = await api.getUserSlotInfoList(pageOffset, PAGE_SIZE);
      const { code, data } = res;
      var finished = false;
      var resultList = [];
      if (code == RES_COMMON_CODE.SUCCESS) {
        if (data.records.length < PAGE_SIZE) {
          finished = true;
        }
        resultList = _.forEach(data.records, function (value) {
          let map = new Map(Object.entries(value.winLines));
          value.winLineArray = Array.from(map.values());
        });
        if (isRefresh) {
          commit("updateUserListRefreshing", { data: false });
          resultList = data.records;
        } else {
          resultList = _.concat(state.userSlotHistoryList, data.records);
        }
        pageOffset++;
        commit("updateUserListError", { data: false });
        commit("updateUserListLoading", { data: false });
        commit("updateUserSlotHistoryList", {
          data: resultList,
          nextOffset: pageOffset,
          finished: finished,
        });
      } else {
        commit("updateUserListLoading", { data: false });
        commit("updateUserListError", { data: true });
      }
    },
    async getSlotElements({ commit }) {
      const res = await api.getSlotConfigInfo();
      const { code, data } = res;
      if (code == RES_COMMON_CODE.SUCCESS) {
        let normalElements = [];
        let specialElements = [];
        if (data.elements) {
          _.forEach(data.elements, function (value) {
            let odds = [];
            if (value.oddsLeft2 > 0) {
              odds.push({
                left: 2,
                odd: value.oddsLeft2,
              });
            }
            if (value.oddsLeft3 > 0) {
              odds.push({
                left: 3,
                odd: value.oddsLeft3,
              });
            }
            if (value.oddsLeft4 > 0) {
              odds.push({
                left: 4,
                odd: value.oddsLeft4,
              });
            }
            if (value.oddsLeft5 > 0) {
              odds.push({
                left: 5,
                odd: value.oddsLeft5,
              });
            }
            value.odds = odds;
            if (value.elType == ELEMENT_TYPE.normal) {
              normalElements.push(value);
            } else {
              if (value.elType == ELEMENT_TYPE.scatter) {
                value.odds = FreeOdds;
              }
              specialElements.push(value);
            }
          });
          commit("updateSlotElement", {
            normal: normalElements,
            special: specialElements,
          });
        }
      }
    },
  },
  getters: {},
};
